import type React from "react";

import styled from "styled-components";

import type { State } from "api/services/appointment/schemas/shared";
import { translateAppointmentState } from "utils/translations";

interface Props {
  className?: string;
  state: State | null;
}

export const AppointmentState: React.FC<Props> = ({ className, state }) => {
  if (!state) {
    return <></>;
  }

  return <Container className={className}>{translateAppointmentState(state)}</Container>;
};

const Container = styled.span`
  text-transform: uppercase;
`;
